import { render, staticRenderFns } from "./ProformaInvoicePosting.vue?vue&type=template&id=3ecc9e22"
import script from "./ProformaInvoicePosting.vue?vue&type=script&lang=js"
export * from "./ProformaInvoicePosting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports